import React, { useState } from "react";
import AddAccount from "./AddAccount";
import AddPersonalAccount from "./AddPersonalAccount";

export default function AddAccountContainer() {
  const [type, setType] = useState(null);

  // Function to reset view, passed to child forms
  const handleBack = () => setType(null);

  return (
    <div style={styles.wrapper}>
      <header style={styles.header}>
        <h2 style={styles.mainTitle}>Add New Account</h2>
        <p style={styles.mainSubtitle}>
          Choose the type of trading account you want to add.
        </p>
      </header>

      {/* ACCOUNT TYPE SELECTION GRID */}
      {!type && (
        <div style={styles.selectorGrid}>
          <div 
            style={styles.selectionCard} 
            onClick={() => setType("prop")}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#0ea5e9")}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#1e293b")}
          >
            <h3 style={styles.cardTitle}>Prop Firm Account</h3>
            <p style={styles.cardText}>
              Funded or evaluation accounts from prop firms like Apex, FTMO,
              QuantTekel, etc.
            </p>
          </div>

          <div 
            style={styles.selectionCard} 
            onClick={() => setType("personal")}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#0ea5e9")}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#1e293b")}
          >
            <h3 style={styles.cardTitle}>Personal Account</h3>
            <p style={styles.cardText}>
              Your own capital account with brokers or exchanges (Zerodha,
              Delta, Binance, etc.)
            </p>
          </div>
        </div>
      )}

      {/* RENDER FORMS */}
      {type === "prop" && (
        <div style={styles.formContainer}>
          <AddAccount onBack={handleBack} />
          <button style={styles.backBtn} onClick={handleBack}>
            ← Back
          </button>
        </div>
      )}

      {type === "personal" && (
        <div style={styles.formContainer}>
          <AddPersonalAccount onBack={handleBack} />
          <button style={styles.backBtn} onClick={handleBack}>
            ← Back
          </button>
        </div>
      )}
    </div>
  );
}

const styles = {
  wrapper: {
    marginBottom: 60,
    padding: "0 10px"
  },
  header: {
    marginBottom: 30
  },
  mainTitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#fff",
    marginBottom: "4px"
  },
  mainSubtitle: {
    color: "#9ca3af",
    fontSize: "14px"
  },
  selectorGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
    marginTop: "10px"
  },
  selectionCard: {
    background: "rgba(13, 17, 23, 0.4)",
    border: "1px solid #1e293b",
    borderRadius: "12px",
    padding: "24px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "600",
    margin: 0
  },
  cardText: {
    fontSize: "14px",
    color: "#9ca3af",
    lineHeight: "1.5",
    margin: 0
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Keeps the back button aligned left
    maxWidth: "600px",
    margin: "0 auto"
  },
  backBtn: {
    marginTop: "10px",
    background: "transparent",
    color: "#4b5563",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    padding: "10px 0",
    transition: "color 0.2s",
    marginLeft: "20px" // Aligns with the card padding
  }
};